__turbopack_context__.v({
  "className": "jetbrains_mono_560cdd6e-module__bD-tLa__className",
  "variable": "jetbrains_mono_560cdd6e-module__bD-tLa__variable",
});
